// extracted by mini-css-extract-plugin
export var boxed = "ComponentReviewsSpotlight-module--boxed--7571e";
export var carouselSlider = "ComponentReviewsSpotlight-module--carouselSlider--4214d";
export var controls = "ComponentReviewsSpotlight-module--controls--2ebf2";
export var heading = "ComponentReviewsSpotlight-module--heading--d15a1";
export var itemWrapper = "ComponentReviewsSpotlight-module--itemWrapper--1cd53";
export var pageIndicator = "ComponentReviewsSpotlight-module--pageIndicator--f568f";
export var section = "ComponentReviewsSpotlight-module--section--3df0f";
export var stepperButton = "ComponentReviewsSpotlight-module--stepperButton--d7eda";